export enum RolePermissionObjects {
    Agent = "GLOBAL_Agent",
    AgentGroup = "GLOBAL_AgentGroup",
    AgentGroupOrgLevel = "GLOBAL_AgentGroup_OrgLevel",
    AgentJurisdiction = "GLOBAL_AgentJurisdiction",
    AgentOrgLevel = "GLOBAL_Agent_OrgLevel",
    AiUsageRecord = "GLOBAL_AiUsageRecord",
    AnalyticalMethod = "GLOBAL_AnalyticalMethod",
    ApiToken = "GLOBAL_ApiToken",
    AptTask = "GLOBAL_AptTask",
    CalibrationEquipment = "GLOBAL_CalibrationEquipment",
    Comment = "GLOBAL_Comment",
    Control = "GLOBAL_Control",
    ControlHierarchyBucket = "GLOBAL_ControlHierarchyBucket",
    ControlOrganizationLevelSeg = "GLOBAL_ControlOrganizationLevelSeg",
    CustomMap = "GLOBAL_CustomMap",
    CustomMapBuilding = "GLOBAL_CustomMapBuilding",
    DeviceCalibrationHistory = "GLOBAL_DeviceCalibrationHistory",
    Email = "GLOBAL_Email",
    EquipmentType = "GLOBAL_EquipmentType",
    FileAttachment = "GLOBAL_FileAttachment",
    HrisConfiguration = "GLOBAL_HrisConfiguration",
    IhLabResult = "GLOBAL_IhLabResult",
    Jurisdiction = "GLOBAL_Jurisdiction",
    JurisdictionOrgLevel = "GLOBAL_Jurisdiction_OrgLevel",
    JurisdictionRiskConfig = "GLOBAL_JurisdictionRiskConfig",
    Lab = "GLOBAL_Lab",
    LabRequisition = "GLOBAL_LabRequisition",
    Location = "GLOBAL_Location",
    LocationAssignment = "GLOBAL_LocationAssignment",
    LocationAssignmentMassContribution = "GLOBAL_LocationAssignmentMassContribution",
    LocationGroup = "GLOBAL_LocationGroup",
    MappingGeofencedZoneGroup = "GLOBAL_MappingGeofencedZoneGroup",
    MappingGroup = "GLOBAL_MappingGroup",
    MappingHistory = "GLOBAL_MappingHistory",
    MasterAgent = "GLOBAL_MasterAgent",
    Note = "GLOBAL_Note",
    Notification = "GLOBAL_Notification",
    NotificationSettings = "GLOBAL_NotificationSettings",
    OelType = "GLOBAL_OelType",
    OrganizationLevel = "GLOBAL_OrganizationLevel",
    Parameter = "GLOBAL_Parameter",
    Ppe = "GLOBAL_PPE",
    PpeAssignment = "GLOBAL_PpeAssignment",
    Process = "GLOBAL_Process",
    Report = "GLOBAL_Report",
    ReportTemplate = "GLOBAL_ReportTemplate",
    RiskAssessment = "GLOBAL_RiskAssessment",
    RiskRegister = "GLOBAL_RiskRegister",
    RolePermission = "GLOBAL_RolePermission",
    Sample = "GLOBAL_Sample",
    SampleMedia = "GLOBAL_SampleMedia",
    SampleTask = "GLOBAL_SampleTask",
    SamplingEquipment = "GLOBAL_SamplingEquipment",
    SEG = "GLOBAL_SEG",
    SegOrgLevel = "GLOBAL_Seg_OrgLevel",
    SegOrgLevelHistory = "GLOBAL_SegOrgLevelHistory",
    SegTaskGroup = "GLOBAL_Seg_TaskGroup",
    Sensor = "GLOBAL_Sensor",
    SensorAssignment = "GLOBAL_SensorAssignment",
    SensorAssignmentParameter = "GLOBAL_SensorAssignmentParameter",
    Shift = "GLOBAL_Shift",
    SiteCreditBalance = "GLOBAL_SiteCreditBalance",
    Survey = "GLOBAL_SampleSurvey",
    TaskAssignment = "GLOBAL_TaskAssignment",
    TaskAssignmentMassContribution = "GLOBAL_TaskAssignmentMassContribution",
    TaskGroup = "GLOBAL_TaskGroup",
    TaskGroupOrgLevel = "GLOBAL_TaskGroup_OrgLevel",
    TenantRisk = "GLOBAL_TenantRisk",
    User = "GLOBAL_AspNetUser",
    UserAction = "GLOBAL_UserAction",
    UserRole = "GLOBAL_UserRole",
    ZoneRiskValueHistory = "GLOBAL_ZoneRiskValueHistory",
    DashboardView = "GLOBAL_DashboardView",
    GridView = "GLOBAL_GridView",
    SampleTemplate = "GLOBAL_SampleTemplate",
    SurveyTemplate = "GLOBAL_SurveyTemplate",
    Pii = "GLOBAL_Pii",
    AccessLog = "GLOBAL_AccessLog",
    JobDictionary = "GLOBAL_JobDictionary",
    JobDictionaryMapping = "GLOBAL_JobDictionaryMapping",
    SegSamplingPlan = "GLOBAL_SegSamplingPlan",
    SamplingPlan = "GLOBAL_SamplingPlan",
    AiAnalystAccess = "GLOBAL_AiAnalyst",
}
